import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import API_URL from "../../config";
import {
  ErrorNotification,
  SuccessNotification,
} from "../../tosterNotification/tosters";

const AmbassadorUserList = () => {
  const [ambassadorUserProfiles, setAmbassadorUserProfiles] = useState([]);
  const [search, setSearch] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [duration, setDuration] = useState("1 Month");

  const fetchAmbassadorUserProfiles = async () => {
    try {
      const { data } = await axios.get(
        `${API_URL}/api/ambassador/ambassador-users`,
      );

      setAmbassadorUserProfiles(data.ambassadorUserProfiles);
    } catch (error) {
      ErrorNotification(
        error?.response?.data?.message || "Something went wrong.",
      );
    }
  };

  useEffect(() => {
    fetchAmbassadorUserProfiles();
  }, []);

  const filteredUsers = useMemo(() => {
    return ambassadorUserProfiles.filter((user) => {
      const value = search.toLowerCase();

      return (
        `${user.firstname} ${user.lastname}`.toLowerCase().includes(value) ||
        user.email.toLowerCase().includes(value)
      );
    });
  }, [ambassadorUserProfiles, search]);

  const openPopup = (user) => {
    setSelectedUser(user);
    setDuration("1 Month");
    setShowPopup(true);
  };

  const confirmExtension = async () => {
    try {
      const response = await axios.post(
        `${API_URL}/api/ambassador/extent-ambassador-users-subscription`,
        {
          userId: selectedUser._id,
          duration: duration,
        },
      );
      if (response.data.success) {
        SuccessNotification("Subscription updated successfully");
        setShowPopup(false);
        setAmbassadorUserProfiles((prev) =>
          prev.map((u) =>
            u._id === response.data.user._id ? response.data.user : u,
          ),
        );

        setSelectedUser(response.data.user);

        SuccessNotification("Subscription updated successfully");
        setShowPopup(false);
        return;
      }
    } catch (error) {
      console.error("Something went wrong !");
      ErrorNotification(
        "Something went wrong while updating the subscription of user",
      );
      setShowPopup(false);
      return;
    }
  };

  return (
    <>
      <style>{`
        body{
          background:#f8f9fa;
        }

        .page-heading{
          font-weight:700;
          color:#000;
        }

        .search-box{
          height:52px;
          border-radius:10px;
          border:1px solid #ddd;
          box-shadow:none !important;
        }

        .search-box:focus{
          border-color:#6600cc;
        }

        .subscription-btn{
          background:#6600cc;
          color:#fff;
          border:none;
          transition:.3s;
          font-weight:600;
          border-radius:8px;
        }

        .subscription-btn:hover{
          background:#006600;
          color:#fff;
        }

        .cancel-btn{
          border:1px solid #ddd;
          color:#000;
          background:#fff;
          font-weight:600;
        }

        .cancel-btn:hover{
          background:#f5f5f5;
        }

        .confirm-btn{
          background:#6600cc;
          color:#fff;
          font-weight:600;
        }

        .confirm-btn:hover{
          background:#006600;
          color:#fff;
        }

        .user-card{
          border:none;
          border-radius:14px;
          height:100%;
          transition:.3s;
          box-shadow:0 8px 25px rgba(0,0,0,.08);
        }

        .user-card:hover{
          transform:translateY(-5px);
          box-shadow:0 15px 35px rgba(0,0,0,.12);
        }

        .user-email{
          font-size:.92rem;
          color:#555;
          word-break:break-word;
        }

        .modal-backdrop-custom{
          position:fixed;
          inset:0;
          background:rgba(0,0,0,.55);
          display:flex;
          justify-content:center;
          align-items:center;
          z-index:9999;
          padding:20px;
        }

        .popup-card{
          width:100%;
          max-width:520px;
          background:#fff;
          border-radius:15px;
          padding:25px;
          animation:popup .25s ease;
        }

        @keyframes popup{
          from{
            opacity:0;
            transform:scale(.9);
          }
          to{
            opacity:1;
            transform:scale(1);
          }
        }

        @media(max-width:576px){

          .popup-card{
            padding:18px;
          }

          .popup-footer{
            flex-direction:column;
          }

          .popup-footer button{
            width:100%;
          }
        }

      `}</style>

      <div className="container-fluid py-4 px-lg-4 px-3">
        <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3 mb-4">
          <h2 className="page-heading m-0">Ambassador User Profiles</h2>

          <input
            className="form-control search-box"
            placeholder="Search by name or email..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ maxWidth: 420 }}
          />
        </div>

        <div className="row g-4">
          {filteredUsers.map((user) => (
            <div className="col-12 col-sm-6 col-lg-4 col-xl-3" key={user._id}>
              <div className="card user-card">
                <div className="card-body d-flex flex-column">
                  <h5 className="fw-bold text-main">
                    {user.firstname} {user.lastname}
                  </h5>

                  <p className="user-email mb-3">{user.email}</p>

                  <div className="mb-3">
                    <small className="text-sub d-block">
                      Subscription Ends
                    </small>

                    <span className="fw-semibold text-main">
                      {new Date(user.subscriptionEndDate).toLocaleDateString()}
                    </span>
                  </div>

                  <button
                    className="btn subscription-btn mt-auto w-100"
                    onClick={() => openPopup(user)}
                  >
                    Extend Subscription
                  </button>
                </div>
              </div>
            </div>
          ))}

          {filteredUsers.length === 0 && (
            <div className="col-12">
              <div className="text-center py-5">
                <h5>No users found.</h5>
              </div>
            </div>
          )}
        </div>
      </div>

      {showPopup && (
        <div className="modal-backdrop-custom">
          <div className="popup-card">
            <h4 className="fw-bold text-black mb-2">Extend Subscription</h4>

            <p className="text-secondary mb-4">
              <strong>
                {selectedUser?.firstname} {selectedUser?.lastname}
              </strong>
            </p>

            <label className="fw-semibold text-black">Select Duration</label>

            <select
              className="form-select mb-4"
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
            >
              <option>1 Month</option>
              <option>3 Months</option>
              <option>6 Months</option>
              <option>1 Year</option>
            </select>

            <div className="d-flex gap-3 justify-content-end popup-footer">
              <button
                className="btn cancel-btn px-4"
                onClick={() => setShowPopup(false)}
              >
                Cancel
              </button>

              <button
                className="btn confirm-btn px-4"
                onClick={confirmExtension}
              >
                Confirm Subscription Extension
              </button>
            </div>
          </div>
        </div>
      )}
      <style>{`
        .text-main {
          color : #000
        }
        .text-sub {
          color : #6600cc
        }
      `}</style>
    </>
  );
};

export default AmbassadorUserList;
